import { DataBean } from "../DataBean";

export class FixedAssetImages extends DataBean {

  public async getFixedAssetImagesCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getFixedAssetImagesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteFixedAssetImages(idfixedassetimages: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteFixedAssetImages_Number", [idfixedassetimages]);
  }

  public async updateFixedAssetImages(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.FixedAssetImages_updateFixedAssetImages_com.orange.finance.processcontract.bean.FixedAssetImages",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.FixedAssetImages",
        },
      ]
    );
  }
}
